var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretUpDown20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0063 8.4975C14.7459 8.4975 14.4956 8.39757 14.2954 8.20771L10 3.91078L5.70463 8.20771C5.31414 8.59743 4.68335 8.59743 4.29287 8.20771C3.90238 7.81799 3.90238 7.18844 4.29287 6.79872L9.28911 1.79229C9.6796 1.40257 10.3104 1.40257 10.7009 1.79229L15.7071 6.78872C16.0976 7.17844 16.0976 7.80799 15.7071 8.19772C15.5069 8.39757 15.2566 8.48751 14.9962 8.48751L15.0063 8.4975Z",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99374 12.0025C5.25407 12.0025 5.50438 12.1024 5.70463 12.2923L10 16.5892L14.2954 12.2923C14.6859 11.9026 15.3166 11.9026 15.7071 12.2923C16.0976 12.682 16.0976 13.3116 15.7071 13.7013L10.7109 18.7077C10.3204 19.0974 9.68961 19.0974 9.29912 18.7077L4.29287 13.7113C3.90238 13.3216 3.90238 12.692 4.29287 12.3023C4.49312 12.1024 4.74343 12.0125 5.00375 12.0125L4.99374 12.0025Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpDown20);
export default __webpack_public_path__ + "static/media/CaretUpDown-20.a78af8f6d6f4a61c07faa702acf9d50f.svg";
export { ForwardRef as ReactComponent };